import { IconDeviceLaptop } from "@repo/ui/icons";
import { DiagramSlide, type StepDef } from "./DiagramSlide";
import type { NodeDef } from "@components/architecture-data";

const DEVELOPER_NODE: NodeDef = {
  id: "developer",
  color: "violet",
  icon: IconDeviceLaptop,
  label: "Developer",
  desc: "",
  x: 1540,
  y: 88,
  layers: ["all"],
};

const STEPS: StepDef[] = [
  {
    key: "connect",
    label: "Connect",
    nodes: new Set(["developer", "nullctl"]),
    arrows: [{ from: "developer", to: "nullctl", color: "#a78bfa" }],
    caption: "User runs nullctl adb connect",
  },
  {
    key: "authenticate",
    label: "Authenticate",
    nodes: new Set(["nullctl", "cpapi", "auth", "groupapp", "sso", "idp"]),
    arrows: [
      { from: "nullctl", to: "cpapi", color: "#22d3ee" },
      { from: "cpapi", to: "auth", color: "#60a5fa" },
      { from: "auth", to: "groupapp", color: "#22d3ee" },
      { from: "groupapp", to: "sso", color: "#fb923c" },
      { from: "sso", to: "idp", color: "#a78bfa" },
    ],
    caption: "Authentication via SSO",
  },
  {
    key: "proxy",
    label: "Proxy",
    nodes: new Set(["emulators", "cpapi", "nullctl"]),
    arrows: [
      {
        from: "emulators",
        to: "cpapi",
        color: "#60a5fa",
        bidirectional: true,
      },
      {
        from: "cpapi",
        to: "nullctl",
        color: "#22d3ee",
        bidirectional: true,
      },
    ],
    caption: "ADB connection persists via local proxy",
  },
];

export function SecureAdbSlide() {
  return (
    <DiagramSlide
      title="Secure ADB Connection"
      subtitle="Authenticated ADB access to cloud emulators via nullctl proxy"
      steps={STEPS}
      extraNodes={[DEVELOPER_NODE]}
    />
  );
}
